export default __webpack_public_path__ + "static/smart-city-small-230ea0aedd3278bef79088a359d9038a.jpg";